import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';

export class GoalRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const settings = getters.session.getUserSettings();
    return (
      (settings?.isAgent() && settings?.isGoalsForAgentsEnabled) ||
      super.canAccessRouteFromContext()
    );
  }
}
